import React, { Fragment, useEffect, useRef, useState } from 'react'
import styles from "@/styles/Activation/activation.module.scss";
import Slider from 'react-slick';
import Image from "../../../../components/common/Image";
// import { Document, Page, pdfjs } from "react-pdf";
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const PrevArrow = (props) => {
    return (
        <a className={`${styles._arrow} ${props.currentSlide > 0 && styles._arrow_prev}`} href="#" onClick={()=>{props.onClick(), props.handleCurrentFile(props.currentSlide)}}></a>
    );
  }
  
  const NextArrow = (props) => {
    return (
        <a className={`${styles._arrow} ${props.currentSlide + 1 !== props.slideCount && styles._arrow_next}`} href="#" onClick={()=>{props.onClick(), props.handleCurrentFile(props.currentSlide)}}></a>
    );
  }

const ViewUploads = (props:any) => {
    const [numPages, setNumPages] = useState(1);
    const [currentFile, setCurrentFile] = useState(0);
    const isMobile = window.innerWidth < 991
    const targetRef:any = useRef(null);
    const [pdfContainerWidth,setPdfContainerWidth]=useState(1000);

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages); 
      }

    useEffect(()=>{
        if(targetRef && targetRef.current && targetRef.current.offsetWidth){
          setPdfContainerWidth(targetRef.current.offsetWidth)
        }
        },[targetRef.current])

    const slideRef = useRef<any>(0)
    const settings = {
        infinite: false,
        speed: 500, 
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <NextArrow handleCurrentFile={(index) =>{setCurrentFile(index + 1)}}/>,
        prevArrow: <PrevArrow handleCurrentFile={(index) =>{setCurrentFile(index - 1)}}/>,
    };

  return (
    <div className={styles.viewUploads} ref={targetRef}>
        <div className={styles.file_name}>{props.files[currentFile].name  || ""}</div>
        <Slider className={styles.slick_slider} {...settings} ref={slideRef}>
            {props.files.map((file, index) => {
                return <Fragment key={file.name}>
                    {file.name.slice(file.name.lastIndexOf('.')) == ".pdf"  
                        ?
                            <div className={styles.pdfView}>
                                <Document file={file.url} onLoadSuccess={onDocumentLoadSuccess}>
                                {Array.from({ length: numPages }, (_, index) => (
                                    <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    renderAnnotationLayer={false}
                                    renderTextLayer={false}
                                    width={pdfContainerWidth-10}     
                                    loading={""}      
                                    />
                                ))}
                                </Document>
                            </div>
                        :
                            <div className={styles.viewFile}>
                                <div className={styles.onlyImage}>
                                <i style={{backgroundImage: `url("${file.url}")`}}></i>
                                </div>
                            </div>
                    }
                </Fragment>
            })}
        </Slider>
        <div className={styles.fileCount}>{`${currentFile + 1}/${props.files.length}`}</div>
    </div>
  )
}

export default ViewUploads